import { isSubTreeKey } from '../../../client/components/NavigationMenu/utils';
import { both } from 'rambda';

const transformKey = (key) =>
  key && key.toLowerCase().replace('.service.json', '');

const hasUpperCase = (key) => /[A-Z]/g.test(key);
const shouldChangeKey = (key) =>
  hasUpperCase(key) || key.includes('.service.json');

export const changeSubTreeKeyVisitor = (node) => {
  Object.keys(node)
    .filter(both(isSubTreeKey, shouldChangeKey))
    .forEach((key) => {
      node[transformKey(key)] = { ...node[key] };
      delete node[key];
    });
  return node;
};
